import CheckContainer from 'components/CheckContainer';
import styled from '@emotion/styled';
import { Divider } from 'antd';

import EnterpriseUnlimitedTag from './EnterpriseUnlimitedTag';
import PricingLink from './PricingLink';
import RecomendTag from './RecomendTag';
import { PanelTitle, List, ListItem, PackTip } from './Common';
import { isQuickChat } from 'productLine';
import { T, useTranslate } from '@tolgee/react';

export interface PackageCheckboxProps {
  value?: Pay.PackageId;
  recommendPackageId?: Pay.PackageId;
  isEnterprise?: boolean;
  list: Pay.PackageInfoV2['packageData'];
  disabled?: (isEnterprise: boolean, value?: Pay.PackageV2) => boolean;
  onChange?: (isEnterprise: boolean, value?: Pay.PackageV2) => void;
}

export const PackageCheckboxGroup = (props: PackageCheckboxProps) => {
  const { value, list, recommendPackageId, isEnterprise = false, disabled, onChange } = props;
  const { t } = useTranslate();

  // 企业版套餐
  const enterprise = (
    <ListItem>
      <CheckItem
        checked={isEnterprise}
        onClick={() => {
          onChange?.(true);
        }}
      >
        <PackageCntWrap>
          <span>{t('market.企业版')}</span>
          <span className="py-1">
            {t('managementCenter.sellerPlan.subscriptionTab.enterprisePlan.description')}
          </span>
          <div>
            <EnterpriseUnlimitedTag />
          </div>
        </PackageCntWrap>
      </CheckItem>
    </ListItem>
  );

  return (
    <List>
      {list.map((item) => {
        const { accountNum, id, aiServiceBuyerNum = 0 } = item;
        const checked = id === value;
        const isDisabled = disabled?.(false, item);

        return (
          <ListItem key={id} className={isQuickChat ? '!basis-[220px] !flex-grow-0' : ''}>
            <CheckItem
              disabled={isDisabled}
              checked={checked}
              onChange={() => {
                if (checked) {
                  return;
                }
                onChange?.(false, item);
              }}
            >
              <PackageCntWrap>
                <span>{t(`套餐.${id}`)}</span>
                <span>
                  <T
                    keyName="managementCenter.sellerPlan.subscriptionTab.agentSeats.label"
                    params={{
                      com: <b />,
                      count: accountNum,
                    }}
                  />
                  <span className="px-0.5">+</span>
                  <T
                    keyName="managementCenter.sellerPlan.subscriptionTab.adminSeat.label"
                    params={{
                      com: <b />,
                      count: 1,
                    }}
                  />
                </span>
                {!isQuickChat && (
                  <div>
                    <AiServiceTimes>
                      {t('managementCenter.sellerPlan.subscriptionTab.aiFollowUpPerMonth.label', {
                        count: aiServiceBuyerNum,
                      })}
                    </AiServiceTimes>
                  </div>
                )}
              </PackageCntWrap>
            </CheckItem>
            {recommendPackageId === id && <RecomendTag />}
          </ListItem>
        );
      })}
      {!isQuickChat && enterprise}
    </List>
  );
};

export const PackageSelectPanel = (props: PackageCheckboxProps) => {
  const { t } = useTranslate();

  return (
    <div>
      <PanelTitle>
        {t('managementCenter.sellerPlan.subscriptionTab.section.selectPlan')}
        <Divider type="vertical" />
        {!isQuickChat && <PackTip>{t('以下套餐含有1个管理员账号')}</PackTip>}
      </PanelTitle>
      <PackageCheckboxGroup {...props} />
      {!isQuickChat && <PricingLink />}
    </div>
  );
};

const PackageCntWrap = styled.div`
  potions: relative;
  min-width: 160px;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;

  b {
    font-size: 20px;
    padding: 0 4px;
  }
`;
const AiServiceTimes = styled.span`
  height: 18px;
  padding: 2px 4px;
  font-weight: 400;
  font-size: 12px;
  color: #336fff;
  line-height: 18px;
  background: #f0f7ff;
  border-radius: 4px;
`;

const CheckItem = styled(CheckContainer)({
  width: '100%',
  borderRadius: '4px',
  padding: 16,
});
